<script>
import Icon from './Icon.svelte';

export let reason = '';
</script>

<span class="warning" title="{reason}">
  <Icon name="warning"></Icon>
</span>

<style>
.warning {
  color: #fc0;
  filter:drop-shadow(0 0 .5px #000);
}
</style>